export const ROOT = '/'
export const MY_CALENDARS = '/my-calendars'

export const ADD_CALENDAR = `${MY_CALENDARS}/add-calendar`
export const ADD_CALENDAR_FORM = `${MY_CALENDARS}/add-calendar-form`
export const INFO_CALENDAR = `${MY_CALENDARS}/info/:calendarId`
export const EDIT_CALENDAR = `${MY_CALENDARS}/edit/:calendarId`

export const AUTHORIZATION = '/authorization'
